import { ShieldCheck, Wifi, Fingerprint, Zap } from "lucide-react";

export const Solution = () => {
    return (
        <section
            id="solution"
            data-testid="solution-section"
            className="relative bg-white py-28 md:py-36 overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="text-xs md:text-sm font-bold uppercase tracking-[0.28em] text-[#F0493E]">
                        Our Solution
                    </span>
                    <h2 className="mt-6 font-display font-extrabold text-4xl md:text-6xl leading-[0.98] tracking-tighter text-[#0A1428] text-balance">
                        A purpose-built dispenser
                        <br />
                        for the moment that matters.
                    </h2>
                    <p className="mt-8 text-lg text-slate-600 max-w-2xl leading-relaxed font-medium">
                        Kairos units are smart, secure, and built for reliable
                        access. Each station dispenses over-the-counter
                        Naloxone when activated and automatically reloads the
                        next dose for the next use — turning any wall,
                        hallway, or cell block into a ready access point for
                        emergency supplies.
                    </p>
                </div>

                <div className="reveal mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200 border border-slate-200">
                    <Feature
                        icon={Zap}
                        title="Instant access"
                        desc="Tamper-resistant release opens immediately in an emergency — no app, no account, no delay."
                        testid="solution-feature-access"
                    />
                    <Feature
                        icon={Wifi}
                        title="Auto-alerts staff & EMS"
                        desc="The moment a unit is activated, on-site staff and emergency services are notified — so bystanders can focus on the person needing help."
                        testid="solution-feature-telemetry"
                    />
                    <Feature
                        icon={Fingerprint}
                        title="Audit-grade logs"
                        desc="Compliance-ready event history for institutional reporting and oversight."
                        testid="solution-feature-audit"
                    />
                    <Feature
                        icon={ShieldCheck}
                        title="Hardened enclosure"
                        desc="ASTM-rated materials engineered for jails, transit, and outdoor sites."
                        testid="solution-feature-enclosure"
                    />
                </div>
            </div>
        </section>
    );
};

const Feature = ({ icon: Icon, title, desc, testid }) => (
    <div
        data-testid={testid}
        className="group bg-white p-8 md:p-10 hover:bg-slate-50 transition-colors"
    >
        <div className="h-12 w-12 grid place-items-center border border-[#0A1428] group-hover:border-[#F0493E] transition-colors">
            <Icon size={20} strokeWidth={1.5} className="text-[#F0493E]" />
        </div>
        <h3 className="mt-8 font-display font-bold text-xl md:text-2xl text-[#0A1428] tracking-tight">
            {title}
        </h3>
        <p className="mt-3 text-sm md:text-base text-slate-600 leading-relaxed font-medium">
            {desc}
        </p>
        <div className="mt-8 h-px w-10 bg-[#0A1428]" />
    </div>
);
